import { Link, NavLink, Outlet } from 'react-router-dom';
import { FiUsers, FiSettings, FiLogOut, FiMapPin } from 'react-icons/fi';
import { useSelector, useDispatch } from 'react-redux';

import { getSubscription } from '../features/subscription/subscriptionSlice'
import { useEffect, useRef } from 'react';
import useLogout from '../hooks/useLogout';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSubStatus } from '../hooks/useSubStatus'


function Homedash() {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { subInfo, isSuccess: subFetchSuccess } = useSelector((state) => state.subscription);
  const lastStatusRef = useRef(null);
  const { checkingSubStatus, subStatus } = useSubStatus();
  const onLogout = useLogout();

  // Get the subscription information on the user
  useEffect(() => {
    if (user) {
        dispatch(getSubscription());
    }
}, [dispatch, user]); // Ensure `user` is a dependency to avoid unnecessary calls

  // Show a toast if subscription status is anything other than "active"
  useEffect(() => {
  const status = subInfo?.subStatus;
  if (subFetchSuccess && status) {
    const norm = String(status).toLowerCase();
    if (norm !== 'active' && lastStatusRef.current !== norm) {
      toast.warn(`Subscription status: ${status}`, { autoClose: 8000 });
      lastStatusRef.current = norm;
    }
  }
}, [subFetchSuccess, subInfo]);

  


  return (
    <>
      <div className="min-h-screen bg-bg">
        <div className="mx-auto flex min-h-screen max-w-7xl flex-col gap-4 p-4 md:flex-row md:gap-6 md:p-6">
          <aside className="w-full rounded-2xl border border-border bg-surface p-4 shadow-sm md:w-56 md:shrink-0 md:self-start md:sticky md:top-6">
            <h1 className="text-section text-ink">
              {user?.company}
            </h1>

            {!checkingSubStatus && String(subStatus || '').toLowerCase() === 'trialing' && (
              <p className="mt-3 rounded-md border border-warning/30 bg-warning/10 px-3 py-2 text-eyebrow text-warning">
                You’re on a trial. Add a payment method before your trial ends.
                <Link to="/homedash/settings" className="ml-1 underline font-medium">Update billing</Link>
              </p>
            )}

            <nav className="mt-4 space-y-1">
              <NavLink
                to="/homedash/jobsites"
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2 text-label transition ${
                    isActive ? "bg-ink text-white" : "text-ink-2 hover:bg-surface-2" 
                  }`
                }
              >
                <FiMapPin className="h-4 w-4" />
                Jobsites
              </NavLink>
              <NavLink
                to="/homedash/workers"
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2 text-label transition ${
                    isActive ? 'bg-ink text-white' : 'text-ink-2 hover:bg-surface-2'
                  }`
                }
              >
                <FiUsers className="h-4 w-4" />
                Workers
              </NavLink>
              <NavLink
                to="/homedash/settings"
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2 text-label transition ${
                    isActive ? 'bg-ink text-white' : 'text-ink-2 hover:bg-surface-2'
                  }`
                }
              >
                <FiSettings className="h-4 w-4" />
                Settings
              </NavLink>
            </nav>

            <button
              onClick={onLogout}
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-md border border-border px-4 py-2 text-label text-ink-2 transition hover:bg-surface-2"
            >
              <FiLogOut className="h-4 w-4" /> Logout
            </button>
          </aside>

          <main className="min-w-0 flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
}

export default Homedash;
